import { getResource } from "./request";

export async function getTwitterSentiments(data: GetSentimentsAPIReqTypes) {
  const { response, error, code } = await getResource({
    endpoint: "twitter/GetSentiments",
    data,
  });
  return { response, error, code };
}

export async function getTwitterWordCloud(data: GetTwitterWordCloudTypes) {
  const { response, error, code } = await getResource({
    endpoint: "twitter/GetWordcloud",
    data,
  });
  return { response, error, code };
}

export async function getTwitterDistribution(
  data: GetTwitterDistributionTypes
) {
  const { response, error, code } = await getResource({
    endpoint: "twitter/GetDistribution",
    data,
  });
  return { response, error, code };
}

export async function getTwitterProperty(data: GetTwitterPropertyTypes) {
  const { response, error, code } = await getResource({
    endpoint: "twitter/GetTweetProperty",
    data,
  });
  return { response, error, code };
}

export async function getTweetsOptions(data: any) {
  const { response, error, code } = await getResource({
    endpoint: "twitter/GetTweetsOptions",
    data,
  });
  return { response, error, code };
}

export async function getTweets(data: TweetsTypes) {
  const { response, error, code } = await getResource({
    endpoint: "twitter/GetTweets",
    data,
  });
  return { response, error, code };
}

export interface TweetsTypes {
  tweet_table_name:
    | "Crypto Keywords"
    | "Crypto Journalists"
    | "Crypto Media"
    | "Crypto Root Accounts";
  search_value: string;
  property_name: string;
  date_range: string;
}

export interface GetSentimentsAPIReqTypes {
  tweet_table_name: string;
  // grouping_column: string;
}

export interface SentimentsResultsTypes {
  key: string;
  items: {
    sentiment: string;
    count: number;
    percentage: number;
  }[];
}

export interface GetTwitterWordCloudTypes {
  tweet_table_name: string;
  tag_table_name: string;
}

export interface GetTwitterDistributionTypes {
  tweet_table_name: string;
  property_name: string;
}

export interface GetTwitterPropertyTypes {
  tweet_table_name: string;
  property_name: string;
  group_by_year?: boolean;
  create_keyword_items?: boolean;
  group_by_month?: boolean;
  create_year_items?: boolean;
}

export const tweet_table_name_options = [
  "Crypto Root Accounts",
  "Crypto Keywords",
  "Crypto Journalists",
  "Crypto Media",
];

export const property_name_options = [
  "Number Of Tweets",
  "Mean Likes",
  "Mean Retweets",
  "Mean Replies",
];

export const power_index = ["Two", "Three", "Four", "Five", "Six"];

// Forum API
export async function getForumWordCloud(data: GetForumWordCloudTypes) {
  const { response, error, code } = await getResource({
    endpoint: "forum/GetForumWordCloud",
    data,
  });
  return { response, error, code };
}

export async function getForumPosts(data: GetForumPostTypes) {
  const { response, error, code } = await getResource({
    endpoint: "forum/GetForumPosts",
    data,
  });
  return { response, error, code };
}

export interface GetForumWordCloudTypes {
  forum_column_name: string;
}

export interface GetForumPostTypes {
  property_name: string;
  date_range: string;
}
export const forum_column_name_options = ["Tags", "Title", "Content"];

//Reddit API

export async function getRedditSentiments(
  data: GetRedditSentimentsAPIReqTypes
) {
  const { response, error, code } = await getResource({
    endpoint: "reddit/GetRedditSentiments",
    data,
  });
  return { response, error, code };
}

export async function getRedditWordCloud(data: GetRedditWordCloudTypes) {
  data = {
    ...data,
    reddit_column_name: "Title",
  };

  const { response, error, code } = await getResource({
    endpoint: "reddit/GetRedditWordcloud",
    data,
  });
  return { response, error, code };
}

export async function getRedditProperty(data: GetRedditPropertyTypes) {
  const { response, error, code } = await getResource({
    endpoint: "reddit/GetRedditProperty",
    data,
  });
  return { response, error, code };
}

export async function getRedditDistribution(data: GetRedditDistributionTypes) {
  const { response, error, code } = await getResource({
    endpoint: "reddit/GetRedditDistribution",
    data,
  });
  return { response, error, code };
}

export async function getReddits(data: any) {
  const { response, error, code } = await getResource({
    endpoint: "reddit/GetReddits",
    data,
  });
  return { response, error, code };
}

export interface GetRedditAPIPropsType {
  property_name: string;
  post_category: string;
  time_filter: string;
  listing: string;
  search_value: string;
  date_range: string;
}

export interface GetRedditSentimentsAPIReqTypes {
  post_category: string;
  time_filter?: string;
  listing?: string;
  reddit_table?: string;
}
export interface GetRedditWordCloudTypes {
  post_category: string;
  time_filter?: string;
  listing?: string;
  reddit_column_name?: string;
}

export interface GetRedditDistributionTypes {
  property_name: string;
  post_category: string;
  time_filter?: string;
  listing?: string;
  reddit_table?: string;
}

export interface GetRedditPropertyTypes {
  reddit_table: string;
  property_name: string;
  group_by_year?: boolean;
  create_keyword_items?: boolean;
  group_by_month?: boolean;
  create_year_items?: boolean;
  post_category: string;
  time_filter: string;
  listing: string;
}

export const property_name_options_reddit = [
  "Scores",
  "Ups",
  //  "Downs"
];

export const post_catergory_options = [
  "Controversial Posts",
  "Hot Posts",
  "New Posts",
  "Rising Posts",
  "Top Posts",
  "Keyword Posts",
];

export const time_filter_options = [
  "All",
  "Day",
  "Hour",
  "Month",
  "Week",
  "Year",
];

export const listing_options = ["Relevance", "Hot", "Top", "New", "Comments"];

export const reddit_table_options = ["RedditPosts", "RedditComments"];
